import Swiper from 'swiper';
import { ScrollCaptain } from 'scroll-captain';

class ContentSlider {
    constructor(element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-research-ai-landingpage-contentslider',
            sliderValue: 'slider',
            slideValue: 'slide',
            itemWrapperValue: 'items',
            itemValue: 'item',
            itemContentValue: 'item-content',
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);
        this.resizeHandler = window.resizeHandler;
        this.slider = null;
        this.activeIndex = 0;
        this.viewportHeight = window.innerHeight;
        this.initial = true;
        this.initialProgress = 0;

        // Elements
        this.$contentSlider = element;
        this.$slider = this.$contentSlider.querySelector(`[${ this.settings.initAttr }="${ this.settings.sliderValue }"]`);
        this.$$slides = this.$contentSlider.querySelectorAll(`[${ this.settings.initAttr }="${ this.settings.slideValue }"]`);
        this.$itemWrapper = this.$contentSlider.querySelector(`[${ this.settings.initAttr }="${ this.settings.itemWrapperValue }"]`);
        this.$$items = this.$contentSlider.querySelectorAll(`[${ this.settings.initAttr }="${ this.settings.itemValue }"]`);
    }

    initialize() {
        this.initSlider();

        if (this.$itemWrapper) {
            this.detectActiveImage();
        }

        if (this.$$items.length > 0) {
            this.$$items.forEach(($item, index) => {
                this.initAnimation($item, index);
            });
        }

        this.checkSize();

        this.resizeHandler.customFunctions.push(() => {
            this.checkSize();
            this.viewportHeight = window.innerHeight;
            this.slideToActiveImage();
        });
    }

    updateStickyHeight() {
        const paddingBottom = this.$slider.clientHeight - this.$$items[this.$$items.length - 1].clientHeight;
        this.$itemWrapper.style.setProperty('--padding-bottom', paddingBottom);
    }

    checkSize() {
        if (window.innerWidth >= 768) {
            this.updateStickyHeight();
        }
    }

    slideToActiveImage() {
        const currentIndex = this.activeIndex;
        this.findActiveItem();

        if (currentIndex !== this.activeIndex) {
            this.slider.slideTo(this.activeIndex);
        }
    }

    detectActiveImage() {
        const animation = new ScrollCaptain(this.$itemWrapper, {  // eslint-disable-line
            initAttr: this.settings.initAttr,
            onScroll: (progress) => {
                if (this.initial) {
                    this.initialProgress = progress;
                }

                this.slideToActiveImage();
            },
        });
    }

    findActiveItem() {
        if (this.initial) {
            this.initial = false;

            if (this.initialProgress === 1) {
                this.activeIndex = this.$$items.length - 1;

                return;
            }
        }

        let referencePoint = this.viewportHeight - (this.viewportHeight * 0.7);

        if (window.innerWidth >= 768) {
            referencePoint = this.viewportHeight - (this.viewportHeight + 45);
        } else if (window.innerWidth >= 993) {
            referencePoint = this.viewportHeight - (this.viewportHeight + 85);
        }

        let smallestDistance = Infinity;
        let closestIndex = this.activeIndex;

        this.$$items.forEach(($item, index) => {
            const rect = $item.getBoundingClientRect();
            const topEdgePosition = rect.top;

            if (topEdgePosition >= referencePoint) {
                const distanceToReferencePoint = topEdgePosition - referencePoint;

                if (distanceToReferencePoint < smallestDistance) {
                    smallestDistance = distanceToReferencePoint;
                    closestIndex = index;
                }
            }
        });

        this.activeIndex = closestIndex;
    }

    initSlider() {
        this.slider = new Swiper(this.$slider, {
            speed: 1000,
            effect: 'fade',
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            centeredSlides: true,
            centeredSlidesBounds: true,
            allowTouchMove: false,
        });
    }

    initAnimation(element, index) {
        const config = {
            initAttr: this.settings.initAttr,
            top: '70%',
            breakpoints: {
                768: {
                    top: '60%',
                    bottom: '-20%',
                },
            },
        };

        if (index > 0) {
            config.animateContent = {
                opacity: { 0: 0, 100: 1 },
                onscroll: true,
                translateY: { 0: 20 * index, 100: 0 },
                targetSuffix: this.settings.itemContentValue,
            };

            config.breakpoints[768].animateContent = {
                opacity: { 0: 0.1, 100: 1 },
            };
        }

        const animation = new ScrollCaptain(element, config); // eslint-disable-line
    }
}

export { ContentSlider };
